import { PublicClientApplication, InteractionRequiredAuthError, type AccountInfo } from "@azure/msal-browser";
import { apiScope, config } from "./config";

export const msal = new PublicClientApplication({
  auth: {
    clientId: config.clientId,
    authority: `https://login.microsoftonline.com/${config.tenantId}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: { cacheLocation: "localStorage" },
});

export async function initAuth(): Promise<void> {
  if (config.authMode === "dev") return;
  await msal.initialize();
  const result = await msal.handleRedirectPromise();
  if (result?.account) msal.setActiveAccount(result.account);
  else if (!msal.getActiveAccount() && msal.getAllAccounts().length) msal.setActiveAccount(msal.getAllAccounts()[0]);
}

export function currentAccount(): AccountInfo | null {
  return config.authMode === "dev" ? null : msal.getActiveAccount();
}

export function signIn() {
  return msal.loginRedirect({ scopes: [apiScope] });
}

export function signOut() {
  return msal.logoutRedirect({ account: msal.getActiveAccount() ?? undefined });
}

export async function getToken(): Promise<string> {
  const account = msal.getActiveAccount();
  if (!account) {
    await signIn();
    throw new Error("redirecting to sign-in");
  }
  try {
    return (await msal.acquireTokenSilent({ scopes: [apiScope], account })).accessToken;
  } catch (e) {
    if (e instanceof InteractionRequiredAuthError) {
      await msal.acquireTokenRedirect({ scopes: [apiScope], account });
      throw new Error("redirecting to sign-in");
    }
    throw e;
  }
}
